import SmoothScroll from "@/components/site/SmoothScroll";

import { useLang } from "@/components/site/LanguageContext";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { MozzarellaShow } from "@/components/site/MozzarellaShow";
import { Marquee } from "@/components/site/Marquee";
import { Manifesto } from "@/components/site/Manifesto";
import { Experience } from "@/components/site/Experience";
import { MediterraneanStage } from "@/components/site/MediterraneanStage";
import { Team } from "@/components/site/Team";
import { PatriziasBusinessModels } from "@/components/site/PatriziasBusinessModels";
import { GrandEvents } from "@/components/site/GrandEvents";
import { Gallery } from "@/components/site/Gallery";
import { ContactCTA } from "@/components/site/ContactCTA";
import { Footer } from "@/components/site/Footer";
import { PinsaChapter } from "@/pages/Pizzeria";

const OnePagerOpen = () => {
  const { lang } = useLang();
  const it = lang === "it";
  return (
    <section className="bg-[#ece1cd] py-20 md:py-28" data-testid="onepager-open">
      <div className="max-w-[1000px] mx-auto px-6 md:px-10">
        <div className="max-w-2xl mb-10">
          <p className="font-sans text-xs uppercase tracking-[0.35em] text-terracotta mb-4">
            {it ? "Il One-Pager · Da portare via" : "The One-Pager · To take away"}
          </p>
          <h2 className="font-serif text-3xl md:text-5xl text-ink leading-[1.05]">
            {it ? <>Tutto il concept, <em className="italic">in una pagina.</em></> : <>The whole concept, <em className="italic">on one page.</em></>}
          </h2>
        </div>
        <div className="rounded-sm overflow-hidden border border-ink/15 shadow-[0_40px_80px_-30px_rgba(43,14,16,0.4)]">
          <img src="/patrizias-onepager.png" alt="Patrizia's one-pager" data-testid="onepager-image" className="w-full h-auto block" />
        </div>
        <p className="font-sans text-sm text-ink-soft mt-6 text-center">
          <a href="/patrizias-onepager.pdf" download="Patrizias-Live-Mozzarella-Experience.pdf" data-testid="onepager-download-link" className="underline underline-offset-4 decoration-terracotta/50 hover:decoration-terracotta transition-colors">
            {it ? "Scarica la versione PDF" : "Download the PDF version"}
          </a>
        </p>
      </div>
    </section>
  );
};


export default function PatriziasLanding() {
  return (
    <div className="App" data-testid="patrizias-landing">
      <div className="noise-overlay" aria-hidden="true" />
      <SmoothScroll>
        <Header brand="patrizias" />
        <main>
          <Hero />
          <MozzarellaShow />
          <Marquee />
          <Manifesto />
          <Experience />
          <MediterraneanStage />
          <Team />
          <PatriziasBusinessModels />
          <GrandEvents />
          <Gallery brand="patrizias" />
          <div className="bg-wine" data-testid="pinsa-chapter">
            <div className="max-w-[1200px] mx-auto px-6 md:px-10 pt-20 md:pt-28">
              <p className="font-sans text-[11px] uppercase tracking-[0.3em] text-terracotta">Capitolo 2 · Chapter 2</p>
            </div>
            <PinsaChapter isPat />
          </div>
          <OnePagerOpen />
          <ContactCTA />
        </main>
        <Footer brand="patrizias" />
      </SmoothScroll>
    </div>
  );
}
